module.exports = __webpack_public_path__ + "img/tu1.76a28b5f.png";